import * as requestFromServer from "./DashboardCrud";
import { callTypes, dashboardSlice } from "./DashboardSlice";

const {actions} = dashboardSlice;

export const getDashboardData = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getDashboardData()
    .then(response => {
      dispatch(actions.dashboardDataFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const cleanDashboardState = () => dispatch => {
  dispatch(actions.dashboardStateCleaned());
}